import React from "react";
export default function StdCouncil() {
  return <div className="container">총학생회 소개 페이지</div>;
}
